import { createSelector } from "reselect";
import * as api from "@/api/division-manager";

// constants

const prefix = "division-manager/division/users";

const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

// actions

const fetchStart = () => ({ type: FETCH_STARTED, payload: true });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

export function fetchDivisionUsers(divisionId) {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const data = await api.fetchDivisionUsers(divisionId);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

// selectors

const baseSelector = (state) => state.divisionManager.divisionUsers;
export const getIsDivisionUsersFetching = createSelector(baseSelector, (state) => state.isFetching);
export const getDivisionUsers = createSelector(baseSelector, (state) => state.records);

// state

const initialState = {
  records: [],
  error: false,
  isFetching: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        records: action.payload,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        records: [],
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
